/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_RecommendedInputs */

const en_directory_submit_review_recommended = /** @type {(inputs: Directory_Submit_Review_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const zh_directory_submit_review_recommended = /** @type {(inputs: Directory_Submit_Review_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Directory_Submit_Review_RecommendedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_recommended = /** @type {((inputs?: Directory_Submit_Review_RecommendedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_RecommendedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_recommended(inputs)
	return zh_directory_submit_review_recommended(inputs)
});
export { directory_submit_review_recommended as "directory.submit.review.recommended" }